import Api from '@/services/Api'

export default {
    getAll(search) {
        return Api().get('users', {
            params: {
                search: search
            }
        })
    },
    getList(page, limit) {
        return Api().get(`users/${page}`, {
            params: {
                limit: limit
            }
        })
    },
    getById(id) {
        return Api().post(`users/${id}`)
    },
    create(user) {
        return Api().post('users/', user)
    },
    update(user) {
        return Api().put(`users/${user.id}`, user)
    },
    delete(id) {
        return Api().delete(`users/${id}`)
    }
}
